module.exports = __webpack_public_path__ + "static/img/vamaship_logo.2d2f091.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vamaship_logo.png
// module id = rxCx
// module chunks = 1